import {Section} from "./Section";
import {Order} from "../Order";
import {formatNumber} from "../../../helpers/format-number";

export class CartSection extends Section {

  static discountListingElement = document.querySelector('[data-cart="listing"] .discounts')

  constructor(sectionElement) {
    super(sectionElement);
    this.listingElement = this.element.querySelector('[data-cart="listing"]');
    this.productListingElement = this.listingElement.querySelector('.products');
    this.discountListingElement = this.listingElement.querySelector('.discounts');
    this.addNewProductButton = this.element.querySelector('[data-button="prev"]');
    this.nextSectionButton = this.element.querySelector('[data-button="next"]');

    CartSection.productListingElement = this.productListingElement;
  }

  get currentCartItemElements() {
    return Array.from(this.productListingElement.querySelectorAll('[data-uuid]'));
  }

  static placeCartItems() {
    CartSection.productListingElement.innerText = '';

    Order.products.forEach(product => {
      const HTML_TEMPLATE = product.getHtmlTemplate();
      CartSection.productListingElement.append(HTML_TEMPLATE);
    });
  }

  static placeDiscounts() {
    const CART_DATA = CartSection.priceData;
    const CART_DISCOUNT_DATA = CART_DATA.cartDiscountData;
    const DISCOUNT_LISTING = CartSection.discountListingElement;

    DISCOUNT_LISTING.innerText = '';

    for (const [index, discountObject] of Object.entries(CART_DISCOUNT_DATA)) {
      if (discountObject.productDiscountTotal > 0) {
        const DISCOUNT_ITEM = CartSection.getDiscountHtmlTemplate(index, discountObject);
        DISCOUNT_LISTING.append(DISCOUNT_ITEM);
      }
    }
  }

  static get priceData() {
    const DISCOUNT_INFOS = {};
    let cartPriceTotal = 0;

    Order.products.forEach(product => {

      /** CALC PRODUCT PRICE */
      const PRICE_OBJECT = product.calcProductPriceData(product.configSection.id, product.formDataObject);
      const PRODUCT_PRICE_TOTAL = PRICE_OBJECT.priceTotal;
      const TEMPLATE = product.configSection.id;

      cartPriceTotal += PRODUCT_PRICE_TOTAL

      /**
       * PREPARE DISCOUNT DATA //
       * DISCOUNT ONLY IF NO DUAL FABRIC IS AVAILABLE
       */

      // const HAS_DUAL_FABRIC = PRICE_OBJECT.hasDualFabric;
      if (TEMPLATE !== 'order-product-balcony-covering') {

        const QUANTITY = PRICE_OBJECT.quantity;

        const DISCOUNT_OBJECT = DISCOUNT_INFOS[`${TEMPLATE}`] || false;

        const DISCOUNT_20_QUANTITY = product.pageInfos.discountPercent20;
        const DISCOUNT_300_QUANTITY = product.pageInfos.discountPercent300;
        const DISCOUNT_600_QUANTITY = product.pageInfos.discountPercent600;
        const DISCOUNT_1000_QUANTITY = product.pageInfos.discountPercent1000;

        let totalDiscount = 0;
        let activeDiscount = parseInt(DISCOUNT_20_QUANTITY) || false;
        let quantityForDiscount = 20;
        let totalProductQuantity = DISCOUNT_OBJECT ? DISCOUNT_OBJECT.count += QUANTITY : QUANTITY;
        let totalProductPrice = DISCOUNT_OBJECT ? DISCOUNT_OBJECT.productPriceTotal += PRODUCT_PRICE_TOTAL : PRODUCT_PRICE_TOTAL;

        if (TEMPLATE === 'order-product-vertical-slat') {

          if (totalProductQuantity >= 300 && totalProductQuantity < 600) {
            activeDiscount = parseInt(DISCOUNT_300_QUANTITY);
            quantityForDiscount = 300;

          } else if (totalProductQuantity >= 600 && totalProductQuantity < 1000) {
            activeDiscount = parseInt(DISCOUNT_600_QUANTITY);
            quantityForDiscount = 600;

          } else if (totalProductQuantity >= 1000) {
            activeDiscount = parseInt(DISCOUNT_1000_QUANTITY);
            quantityForDiscount = 1000;
          }
        }

        if (totalProductQuantity >= quantityForDiscount) {
          totalDiscount = (activeDiscount * totalProductPrice) / 100;
        }

        DISCOUNT_INFOS[`${TEMPLATE}`] = {
          count: totalProductQuantity,
          discountPercent: activeDiscount,
          productPriceTotal: totalProductPrice,
          productDiscountTotal: totalDiscount,
          discountText: `-${activeDiscount}% ab ${quantityForDiscount} Stk.`,
        }
      }
    })

    let cartPriceToPay = cartPriceTotal;

    for (const [index, discountObject] of Object.entries(DISCOUNT_INFOS)) {
      if (discountObject.productDiscountTotal > 0) {
        cartPriceToPay -= discountObject.productDiscountTotal;
      }
    }

    return {
      cartPriceTotal: cartPriceTotal,
      cartPriceToPay: cartPriceToPay,
      cartDiscountData: DISCOUNT_INFOS
    };
  }

  static updateCart() {
    const CART_DATA = CartSection.priceData;

    CartSection._setPriceToPay(CART_DATA.cartPriceToPay);
    CartSection.placeDiscounts();
  }

  static getDiscountHtmlTemplate(productId, priceObject) {
    const TEMPLATE_HELPER = document.createElement('template');
    const CURRENT_HTML_ELEMENT = document.querySelector(`[data-cart-discount="${productId}"]`)
    const CLONED_NODE = CURRENT_HTML_ELEMENT.cloneNode(true);

    TEMPLATE_HELPER.appendChild(CLONED_NODE);
    const ITEM_TEMPLATE = TEMPLATE_HELPER.firstElementChild;

    const INFO_TEXT_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="discount-text"]');
    const PRICE_ELEMENT = ITEM_TEMPLATE.querySelector('[data-info="price-value"]');
    const DISCOUNT_TEXT = priceObject.discountText;
    const DISCOUNT_PRICE = formatNumber(priceObject.productDiscountTotal * -1);

    INFO_TEXT_ELEMENT.innerText = DISCOUNT_TEXT;
    PRICE_ELEMENT.innerText = DISCOUNT_PRICE;

    return ITEM_TEMPLATE;
  }

  static _setPriceToPay(price) {
    const CART_PRICE_VALUE_ELEMENT = document.querySelector('[data-info="cart-price-value"]');
    CART_PRICE_VALUE_ELEMENT.innerText = formatNumber(price);
  }
}

export const INSTANTIATE_CART_SECTION = () => {
  const CART_SECTION_ELEMENT = document.querySelector('[data-section="cart"]');
  if (!CART_SECTION_ELEMENT) return;

  return new CartSection(CART_SECTION_ELEMENT);
}
